import {REPORTS} from '../actions/const';

import moment from 'moment';

const initialState = {
  resetState: false,
  showModal: false,
  isLoadingAction: false,

  isLoadingEventNameReport: false,
  eventNameReportData: [],

  chartType: 0,
  sorting: {
    column: "event",
    sort: "ascending"
  }
};

function reducer (state = initialState, action) {
  let {type, payload} = action;

  switch (type) {
    case REPORTS:
      if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
        action.payload = {...initialState};
      }
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/Reports.js